import React from 'react';
import FunnelTrackingDashboard from '@/components/admin/FunnelTrackingDashboard';

const FunnelTrackingPage = () => {
  return <FunnelTrackingDashboard />;
};

export default FunnelTrackingPage;
